import React from 'react';
import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SiteAdmin from '../components/SiteAdmin';
import Page from '../../../components/Page';
import { ReportAPI } from '../../../api';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import { CSVLink } from '@mr-yum/react-csv';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useRouteMatch } from 'react-router-dom';
import moment from 'moment';
import DataTable from '../components/DataTable';
import Loader from '../../../components/Loader';
import withAdminOnly from '../components/AdminOnly';

const useStyles = makeStyles({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
  },
  title: {
    marginBottom: '2rem',
  },
  downloadButton: {
    textDecoration: 'none',
  }
});


const formatValue = (value) => {
  if (typeof value === 'boolean'){
    return value.toString();
  }
  return value;
};


const AdminReportPage = () => {
  const match = useRouteMatch();
  const classes = useStyles();
  const [report, setReport] = useState();
  const reportName = match.params && match.params.reportName;
  const now = moment().format('YYYYMMDD-HHmmss');
  const title = report ? report.title : 'Clickability Reports';

  useEffect(() => {
    if (reportName) {
      ReportAPI.getReport(reportName).then(result => setReport(result.payload));
    } else {
      setReport(undefined);
    }
  }, [reportName]);

  return (
    <Page title="Admin Reports">
      <SiteAdmin>
        <Container>
          {report ?
            <div>
              <div className={classes.titleContainer}>
                <Typography variant="h6" color="primary" className={classes.title}>{title}</Typography>
                <CSVLink
                  className={classes.downloadButton}
                  data={report.data}
                  headers={report.fields}
                  filename={`${report.name}-${now}`}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.button}
                    endIcon={<CloudDownloadIcon/>}
                  >
                    Download
                  </Button>
                </CSVLink>
              </div>
              <DataTable
                headers={report.fields}
                rows={report.data}
                formatter={formatValue}
              />
            </div>
            :
            <Loader/>
          }
        </Container>
      </SiteAdmin>
    </Page>
  );
};

export default withAdminOnly(AdminReportPage);
